<template>
  <Modal title="Title" v-model="showFormModal" :mask-closable="false" class-name="card-modal" :width="1300">
    <div slot="header">
      <h4>{{title}}</h4>
    </div>

    <!-- Warning Modal for existing responses -->
    <Modal v-model="showWarningModal" title="Warning" class-name="vertical-center-modal card-modal" :width="500" :closable="false" :mask-closable="false">
      <div class="confirmation-body">
        <p>
          <Icon type="ios-warning" size="48" color="#f90" />
        </p>
        <p style="margin-top: 15px; font-size: 14px;">
          <strong>Warning:</strong> This form already contains recorded responses.
        </p>
        <p style="margin-top: 10px; color: #666;">
          Modifying this form will result in the <strong>loss of all collected data</strong>.
        </p>
        <p style="margin-top: 15px; color: #004f6e;">
          If you wish to keep the existing data, we recommend <strong>creating a new form</strong> instead.
        </p>
      </div>
      <div slot="footer">
        <Button @click="showWarningModal=false; showFormModal=false" class="btn btn-outline-secondary btn-sm">
          Cancel
        </Button>
        <Button type="error" @click="confirmUpdate" class="btn btn-danger btn-sm">
          Modify Anyway
        </Button>
      </div>
    </Modal>

    <SurveyChoices ref="surveyChoices"></SurveyChoices>
    <Form ref="myQuestionnaireForm" :model="myQuestionnaireForm" :rules="ruleValidate" :label-width="100">
      <Row class="widget-container">
        <i-col :xs="4" :sm="4" :md="4" :lg="4">
          <FormItem label="Active">
            <i-switch v-model="myQuestionnaireForm.isActive" :disabled="action=='view'"></i-switch>
          </FormItem>
        </i-col>
        <i-col :xs="16" :sm="16" :md="16" :lg="16">
          <FormItem label="Existing Surveys">
            <Select v-model="selectedSurveyQuestions" multiple transfer :disabled="action==='view'">
              <Option v-for="item in surveyQuestionList" :value="item.formId" :key="item.formId">
                {{item.formName}}
              </Option>
            </Select>
          </FormItem>
        </i-col>
        <i-col :xs="4" :sm="4" :md="4" :lg="4">
          <div v-show="action==='view'">
            <Label size="small" type="primary">Import</Label>
          </div>
          <div v-show="action!=='view'">
            <Button size="small" type="primary" @click="addDuplicates">Import</Button>
          </div>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Form Title" :prop="'title'"
                    :rules="{required: true, message: 'Title cannot be empty', trigger: 'blur'}">
            <Input v-model="myQuestionnaireForm.title" :readonly="action=='view'"></Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <FormItem label="Form Desc" :prop="'desc'">
            <Input v-model="myQuestionnaireForm.desc" type="textarea" :autosize="{minRows: 5,maxRows: 10}"
                   placeholder="Enter something..." :readonly="action=='view'">
            </Input>
          </FormItem>
        </i-col>
        <i-col :xs="24" :sm="24" :md="24" :lg="24">
          <draggable v-model="myQuestionnaireForm.questions" group="people" @start="drag=true" @end="drag=false">
            <FormItem v-for="(question, questionIndex) in myQuestionnaireForm.questions" :key="questionIndex" :label="'Question ' + (questionIndex + 1)" :prop="'questions[' + questionIndex + '].title'" :rules="{required: true, message: 'Question ' + questionIndex +' cannot be empty', trigger: 'blur'}" class="k4-question">
              <Row>
                <i-col :xs="1" :sm="1" :md="1" :lg="1" class="d-flex justify-content-center align-items-center">
                  <Icon class="ico" type="md-reorder" size="20"/>
                </i-col>
                <i-col :xs="6" :sm="6" :md="6" :lg="6">
                  <Input v-model="question.title"
                        :readonly="action=='view'||question.status==0||question.title.toLowerCase()=='id'" :maxlength="maxQuestionLength"></Input>
                </i-col>
                <i-col :xs="4" :sm="4" :md="4" :lg="4">
                  <Select @on-change="(e) => changeType(questionIndex, e)" transfer
                          v-model="question.inputType" placeholder="Select Type"
                          :disabled="action=='view'||question.title.toLowerCase()=='id'||question.status==0">
                    <Option v-for="type in typeList" :key="type.inputType" :value="type.inputType">
                      <Icon :type="type.iconType" size='small' style="margin-right: 5px;"/>
                      {{type.title}}
                    </Option>
                  </Select>
                </i-col>
                <i-col :xs="9" :sm="9" :md="9" :lg="9" style="padding: 0">
                  <FormItem v-for="(choice, ix) in question.choices"
                            :key="ix"
                            :prop="'questions[' + questionIndex + '].choices[' + ix + '].label'"
                            :rules="{required: true, message: 'Choice ' + ix +' cannot be empty', trigger: 'blur'}">
                    <Row>
                      <i-col :xs="22" :sm="22" :md="22" :lg="22">
                        <Input v-model="choice.label"
                              :key="ix" style="width: 100%;"
                              :placeholder="'Choice ' + ix"
                              :type="'text'"
                              :maxlength="maxQuestionLength"
                              :readonly="action=='view'||question.status==0
                              ||question.choices==null||question.type=='text'
                              ||question.title.toLowerCase()=='id'
                              ||choice.label=='HOT'||choice.label=='WARM'||choice.label=='COLD'">
                        </Input>
                      </i-col>
                      <i-col :xs="2" :sm="2" :md="2" :lg="2">
                        <div v-show="action!=='view'">
                          <Button icon="ios-remove-circle-outline" @click="removeChoice(questionIndex, ix)"
                                  title="Remove" class="btn btn-danger btn-sm" v-if="question.canAddChoices"/>
                        </div>
                      </i-col>
                    </Row>
                  </FormItem>
                  <FormItem>
                    <Row>
                      <i-col :xs="24" :sm="24" :md="24" :lg="24" v-show="action!=='view'">
                        <div v-if="question.canAddChoices" style="width: 100%; display: block">
                          <Button
                            icon="ios-add-circle-outline" @click="importChoiceList(questionIndex)"
                            title="Add New Choice" class="btn btn-secondary btn-sm">Import List
                          </Button>
                          <Button
                            icon="ios-add-circle-outline" @click="addChoice(questionIndex)"
                            title="Add New Choice" class="btn btn-primary btn-sm">Add Choice
                          </Button>
                        </div>
                      </i-col>
                    </Row>
                  </FormItem>
                </i-col>
                <i-col :xs="4" :sm="6" :md="4" :lg="4" style="text-align: right">
                  <Button
                    :disabled="action=='view'||question.status==0"
                    v-if="question.title.toLowerCase()!='id'"
                    @click="handleRemove(questionIndex)"
                    icon="md-close" class="btn btn-danger btn-sm">
                    Remove
                  </Button>
                </i-col>
              </Row>
            </FormItem>
          </draggable>

          <FormItem>
            <Button
              :disabled="action=='view'"
              @click="handleAdd" icon="md-add" class="btn btn-primary btn-sm">Add Question
            </Button>
          </FormItem>
        </i-col>
      </Row>
    </Form>
    <div slot="footer">
      <Button @click="handleReset(); showFormModal=false;" style="margin-left: 8px" class="btn btn-secondary-outline btn-sm">
        Cancel
      </Button>
      <Button
        class="submit btn btn-success btn-sm"
        @click="handleCreate('myQuestionnaireForm')"
        v-if="action=='add'">
        Create
      </Button>
      <Button class="submit btn btn-success btn-sm" v-if="action=='edit'"
              @click="handleUpdate('myQuestionnaireForm',myQuestionnaireForm.formId)">Save
      </Button>
    </div>
  </Modal>
</template>

<script>
  import {addForm, updateForm} from '../../services/Forms.service'
  import {getSurveyProcessed} from '../../services/SurveyForms.service'
  import {bus} from '../../main';
  import SurveyChoices from './_surveyChoicesForm'
  import { maxlength } from 'caniuse-lite/data/features';
  import draggable from 'vuedraggable'

  export default {
    components: { SurveyChoices, draggable },
    data() {
      return {
        drag: false,
        index: 0,
        eventId: null,
        companyId: null,
        action: 'add',
        title: 'ADD FORM',
        showFormModal: false,
        showWarningModal: false,
        hasResponses: false,
        pendingUpdateId: null,
        maxQuestionLength: 150,
        myQuestionnaireForm: {
          formId: '',
          title: '',
          desc: '',
          isActive: false,
          isLeadForm: false,
          questions: [{
            index: 0,
            status: 0,
            allowOther: false,
            fieldCode: '',
            formId: 0,
            inputType: '',
            order: 0,
            questionId: 0,
            title: '',
            type: '',
            visible: false,
            choices: [{
              actionOnSync: null,
              choiceId: 0,
              label: '',
              order: 0,
              questionId: 0
            }]
          }]
        },
        typeList: [
          {type: 'text', inputType: 'text', title: 'Free Text', iconType: 'ios-menu-outline'},
          {
            type: 'textArea', inputType: 'textArea', title: 'Free Text field (multiple lines)',
            iconType: 'ios-menu-outline'
          },
          {type: 'text', inputType: 'country', title: 'Country', iconType: 'ios-flag-outline'},
          {type: 'text', inputType: 'date', title: 'Date', iconType: 'ios-calendar-outline'},
          {type: 'text', inputType: 'email', title: 'Email', iconType: 'ios-mail-outline'},
          {type: 'text', inputType: 'phoneNumber', title: 'Phone', iconType: 'ios-call-outline'},
          {type: 'leadRating', inputType: 'leadRating', title: 'Lead Rating', iconType: 'ios-star-outline'},
          {type: 'checkbox', inputType: 'multiChoice', title: 'Multiple Choice', iconType: 'ios-checkbox-outline'},
          {type: 'radioList', inputType: 'singleChoice', title: 'Single Choice', iconType: 'ios-radio-button-on'},
          // Hidden options - Photo and Scan
          // {type: 'photo', inputType: 'photo', title: 'Photo', iconType: 'ios-image-outline'},
          // {type: 'QRCode', inputType: 'scan', title: 'Scan', iconType: 'ios-qr-scanner'},
        ],
        indeterminate: null,
        checkAll: false,
        ruleValidate: {},
        spinShow: true,
        selectedSurveyQuestions: '',
        surveyQuestionList: [],
      }
    },
    methods: {
      openForm(title, action, questionsList) {
        this.handleReset();
        this.showFormModal = true;
        this.title = title;
        this.action = action;
        if (questionsList) {
          this.surveyQuestionList = questionsList;
        }
        if (action == 'add') {
          this.myQuestionnaireForm.isActive = true;
          this.myQuestionnaireForm.isLeadForm = false;
        }
      },
      addDuplicates() {
        const self = this;
        if (!self.myQuestionnaireForm.questions) {
          self.myQuestionnaireForm.questions = [];
        }
        if (self.selectedSurveyQuestions) {
          self.selectedSurveyQuestions.map(s => {
            let item = self.surveyQuestionList.filter(a => a.formId === s);
            let hasData = item !== null ? (item.length > 0 ? true : false) : false;
            if (hasData) {
              let hasQuestions = item[0].questions !== null ? (item[0].questions.length > 0 ? true : false) : false;
              if (hasQuestions) {
                item[0].questions.map(q => {
                  q.canAddChoices = false;
                  if (q.inputType.toLowerCase() === 'multichoice' || q.inputType.toLowerCase() === 'singlechoice') {
                    q.canAddChoices = true;
                  }
                  let exists = self.myQuestionnaireForm.questions.filter(a => a.title === q.title);
                  if (exists) {
                    if (exists.length > 0) {
                    } 
                    else {
                      self.myQuestionnaireForm.questions.push(q);
                    }
                  } 
                  else {
                    self.myQuestionnaireForm.questions.push(q);
                  }
                });
              }
            }
          })
        }
      },
      handleCreate(name) {
        const self = this;
        this.$refs[name].validate((valid) => {
          if (valid) {
            let companies = JSON.parse(localStorage.getItem('companies'));
            let company = companies.
            filter(a => a.companyName === localStorage.getItem('selected_company')
            || a.companyId === parseInt(localStorage.getItem('selected_company')));
            self.companyId = company[0].companyId;

            let eventsList = JSON.parse(localStorage.getItem('events'));
            let event = eventsList
              .filter(a => a.eventName === localStorage.getItem('selected_event')
              || a.eventId === parseInt(localStorage.getItem('selected_event')));
            self.eventId = event[0].eventId;

            const data = Object.assign({}, self.myQuestionnaireForm);
            data['formId'] = 0;
            data['title'] = data.title;
            data['desc'] = data.desc;
            data['questions'] = data.questions;
            data['isActive'] = data.isActive;
            data['companyId'] = self.companyId;
            data['eventId'] = self.eventId;
            data['order'] = 0;
            data['isLeadForm'] = data.isLeadForm;
            data['isSurveyForm'] = true;
            data['leadFormIds'] = null;
            data['surveyFormIds'] = null;

            self.showFormModal = false;
            addForm(data)
              .then(response => {
                data['formId'] = response.data.formId;
                self.$emit('addForm', data);
                self.$Message.success('Form successfully added!');
                bus.$emit('changeSurveyForm', localStorage.getItem('selected_event'));
              })
              .catch(error => {
                console.log(error.response)
                if (error.response.request.responseText) {
                  let errResponse = JSON.parse(error.response.request.responseText)
                  Object.keys(errResponse).map(key => {
                    errResponse[key].map(errMsg => {
                      self.$Message.error(errMsg);
                    })
                  })
                } else {
                  self.$Message.error('Failed adding form');
                }
              });
          }
        })
      },
      handleUpdate(name, id) {
        this.$refs['myQuestionnaireForm'].validate((valid) => {
          if (valid) {
            this.pendingUpdateId = id;
            // Check if responses exist for this form
            this.checkForResponses(id).then(hasResponses => {
              if (hasResponses) {
                // Show warning modal
                this.showWarningModal = true;
              } else {
                // No responses, proceed with update
                this.performUpdate(id);
              }
            }).catch(error => {
              console.log('Error checking responses:', error);
              // In case of error, proceed with update
              this.performUpdate(id);
            });
          }
        })
      },
      checkForResponses(formId) {
        return new Promise((resolve, reject) => {
          let eventsList = JSON.parse(localStorage.getItem('events'));
          let event = eventsList
            .filter(a => a.eventName === localStorage.getItem('selected_event')
            || a.eventId === parseInt(localStorage.getItem('selected_event')))[0];

          if (event) {
            let companies = JSON.parse(localStorage.getItem('companies'));
            let company = companies.filter(a => a.companyName === localStorage.getItem('selected_company')
              || a.companyId === parseInt(localStorage.getItem('selected_company')))[0];
            let companyId = company ? company.companyId : null;
            let eventId = event.eventId;

            getSurveyProcessed(false, companyId, eventId)
              .then(response => {
                // Filter responses for this specific form
                let formResponses = response.data.filter(r => r.formId === formId);
                resolve(formResponses.length > 0);
              })
              .catch(error => {
                reject(error);
              });
          } else {
            resolve(false);
          }
        });
      },
      confirmUpdate() {
        this.showWarningModal = false;
        this.performUpdate(this.pendingUpdateId);
      },
      performUpdate(id) {
        // Update questions' order
        for (let i=0; i<this.myQuestionnaireForm.questions.length; i++) {
          this.myQuestionnaireForm.questions[i].order = i;
        }

        this.showFormModal = false;
        const data = Object.assign({}, this.myQuestionnaireForm);
        updateForm(id, data).then(response => {
          this.$emit('updateForm', id, data);
          this.$Message.success('Form successfully update!');
          bus.$emit('changeSurveyForm', localStorage.getItem('selected_event'));
        }).catch(error => {
          this.$Message.error('Failed updating form');
        });
      },
      setFormValue(params, index) {
        params.questions
          .map((x, i) => {
            x.canAddChoiceList = false;
            x.canAddChoices = false;
            x.choiceList = null;
            if (x.inputType === 'multiChoice') {
              x.canAddChoices = true;
              x.type = 'checkbox';
              x.fieldCode = 'checkbox';
            }
            if (x.inputType === 'radio') {
              x.type = 'leadRating';
              x.fieldCode = 'leadRating';
            }
            if (x.inputType === 'singleChoice') {
              x.canAddChoices = true;
              x.type = 'radioList';
              x.fieldCode = 'radioList';
            }
            if (x.inputType === 'email') {
              x.type = 'text';
              x.fieldCode = 'email';
            }
            if (x.inputType === 'phoneNumber') {
              x.type = 'text';
              x.fieldCode = 'phoneNumber';
            }
            if (x.inputType === 'text') {
              x.type = 'text';
              x.fieldCode = 'text';
            }
            if (x.inputType === 'country') {
              x.type = 'text';
              x.fieldCode = 'country';
            }
            if (x.inputType === 'date') {
              x.type = 'text';
              x.fieldCode = 'date';
            }
            if (x.inputType === 'buttons') {
              x.canAddChoices = true;
              x.type = 'buttonGroup';
              x.fieldCode = 'buttonGroup';
            }
            if (x.inputType === 'textArea') {
              x.type = 'textArea';
              x.fieldCode = 'textArea';
            }
            if (x.inputType === 'photo') {
              x.type = 'photo';
              x.fieldCode = 'photo';
            }
            if (x.inputType === 'scan') {
              x.type = 'QRCode';
              x.fieldCode = 'scan';
            }
            x.status = 1;
            x.icon = this.getQuestionIcon(x);
          });
        let data = Object.assign({}, params);
        delete data['_index'];
        delete data['_rowKey'];
        this.myQuestionnaireForm = data;
      },
      handleReset() {
        this.$refs['myQuestionnaireForm'].resetFields();
        this.selectedSurveyQuestions = '';
        this.surveyQuestionList = [];
        let self = this;
        Object.keys(this.myQuestionnaireForm).forEach(function (key, i) {
          self.myQuestionnaireForm[key] = '';
        });
        bus.$emit('changeSurveyForm', localStorage.getItem('selected_event'));
      },
      handleAdd() {
        if (!this.myQuestionnaireForm.questions) {
          this.myQuestionnaireForm.questions = [];
        }
        
        let dtNum = new Date().getTime();
        let dt = parseInt(dtNum.toString().substring(7, dtNum.toString().length));
        let formId = this.myQuestionnaireForm.formId == "" ? null : this.myQuestionnaireForm.formId;
        let newRow = {
          index: this.myQuestionnaireForm.questions.length,
          status: 1,
          questionId: dt,
          title: '',
          type: 'text',
          formId: formId,
          inputType: 'text',
          fieldCode: '',
          order: dt,
          visible: true,
          allowOther: false,
          choices: null
        };
        this.myQuestionnaireForm.questions.push(newRow);
      },
      handleRemove(index) {
        if (this.myQuestionnaireForm.questions) {
          this.myQuestionnaireForm.questions.splice(index, 1);
        }
      },
      getQuestionIcon(question) {
        let iconType = "";
        let type = question.inputType.toLowerCase();

        if (type === 'email') {
          iconType = 'ios-mail-outline';
        }
        if (type === 'phonenumber') {
          iconType = 'ios-call-outline';
        }
        if (type === 'text') {
          iconType = 'ios-menu-outline';
        }
        if (type === 'date') {
          iconType = 'ios-calendar-outline';
        }
        if (type === 'textarea') {
          iconType = 'ios-menu-outline';
        }
        if (type === 'multichoice') {
          iconType = 'ios-checkbox-outline';
        }
        if (type === 'leadrating') {
          iconType = 'ios-star-outline';
        }
        if (type === 'singlechoice') {
          iconType = 'ios-radio-button-on';
        }
        if (type === 'country') {
          iconType = 'ios-flag-outline';
        }
        if (type === 'photo') {
          iconType = 'ios-image-outline';
        }
        if (type === 'scan') {
          iconType = 'ios-qr-scanner';
        }
        return iconType;
      },
      changeType(index, choiceLabel) {
        let question = this.myQuestionnaireForm.questions[index];
        question.status = true;
        question.canAddChoices = false;
        question.canAddChoiceList = false;
        question.choices = null;

        if (choiceLabel === 'scan') {
          question.type = 'QRCode';
          question.inputType = 'scan';
          question.fieldCode = 'scan';
        }
        if (choiceLabel === 'photo') {
          question.type = 'photo';
          question.inputType = 'photo';
          question.fieldCode = 'photo';
        }
        if (choiceLabel === 'country') {
          question.type = 'text';
          question.inputType = 'country';
        }
        if (choiceLabel === 'email') {
          question.type = 'text';
          question.inputType = 'email';
        }
        if (choiceLabel === 'phoneNumber') {
          question.type = 'text';
          question.inputType = 'phoneNumber';
        }
        if (choiceLabel === 'text') {
          question.type = 'text';
          question.inputType = 'text';
        }
        if (choiceLabel === 'date') {
          question.type = 'text';
          question.inputType = 'date';
        }
        if (choiceLabel === 'textArea') {
          question.type = 'textArea';
          question.inputType = 'textArea';
        }
        if (choiceLabel === 'buttonGroup') {
          question.type = 'buttonGroup';
          question.inputType = 'buttons';
          question.canAddChoices = true;
        }
        if (choiceLabel === 'multiChoice') {
          question.type = 'checkbox';
          question.inputType = 'multiChoice';
          question.canAddChoices = true;
        }
        if (choiceLabel === 'singleChoice') {
          question.type = 'radioList';
          question.inputType = 'singleChoice';
          question.canAddChoices = true;
        }
        if (choiceLabel === 'radio') {
          question.fieldCode = 'rating';
          question.type = 'leadRating';
          question.inputType = 'radio';
          question.choices = [];
          question.choices.push({
            actionOnSync: '',
            choiceId: parseInt(question.questionId.toString() + "0"),
            label: 'HOT',
            order: 0,
            questionId: question.questionId,
            status: status
          }, {
            actionOnSync: '',
            choiceId: parseInt(question.questionId.toString() + "1"),
            label: 'WARM',
            order: 1,
            questionId: question.questionId,
            status: status
          }, {
            actionOnSync: '',
            choiceId: parseInt(question.questionId.toString() + "2"),
            label: 'COLD',
            order: 2,
            questionId: question.questionId,
            status: status
          });
        }
      },
      addChoice(index) {
        const self = this;
        self.myQuestionnaireForm.questions[index].canAddChoiceList = false;
        if (!self.myQuestionnaireForm.questions[index].choices) {
          self.myQuestionnaireForm.questions[index].choices = [];
        }
        let newRow = {
          actionOnSync: '',
          questionId: self.myQuestionnaireForm.questions[index].questionId,
          choiceId: parseInt(self.myQuestionnaireForm.questions[index].questionId.toString() +
            self.myQuestionnaireForm.questions[index].choices.length.toString()),
          label: '',
          order: self.myQuestionnaireForm.questions[index].choices.length + 1,
        };
        self.myQuestionnaireForm.questions[index].choices.push(newRow);
      },
      removeChoice(index, choiceIndex) {
        const self = this;
        self.myQuestionnaireForm.questions[index].canAddChoiceList = false;
        self.myQuestionnaireForm.questions[index].choices.splice(choiceIndex, 1);
      },
      importChoiceList(index) {
        console.log(this.$refs);
        this.$refs['surveyChoices'].openChoices();
        this.$refs['surveyChoices'].setFormValue(this.myQuestionnaireForm.questions, index);
      }
    },
  }
</script>

<style scoped>
  .k4-question {
    cursor: grab;
  }
  .k4-question:hover {
    background-color: var(--blue-lightest);
  }
</style>



// WEBPACK FOOTER //
// src/components/d_MyQuestionnaireForms/_MyQuestionnaireForms.vue